<template>
        <b-form
          class="p-2"
          @submit.prevent="$emit('onSubmit')">

          <b-col>

          <b-row>
            <b-form-group :label="$t('Name')" label-for="name" class="w-100">
              <b-form-input
                id="name"
                v-model="data.name"
                autofocus
                :state="errors && ('name' in errors) ? false : null"
                trim
                autocomplete="off"
                placeholder=""
              />
              <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
                {{ $t(errors.name[0])  }}
              </b-form-invalid-feedback>

            </b-form-group>

        </b-row>

        <b-row>
          <b-form-group :label="$t('Camp Leave')" label-for="leave-camp" :state="null" class="w-100">
            <flat-pickr v-model="data.camp_leave" dateFormat="H:m:s" class="form-control"
                        :class="{ 'is-invalid': errors && ('camp_leave' in errors) }" :config="flatPickerConfig"
                        placeholder="HH:MM:SS" />
            <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                     :state="errors && ('camp_leave' in errors) ? false : null">
              {{ $t(errors.camp_leave[0]) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group :label="$t('Camp Back')" label-for="back-camp" :state="null" class="w-100">
            <flat-pickr v-model="data.camp_back" :state="null" class="form-control"
                        :class="{ 'is-invalid': errors && ('camp_back' in errors) }" :config="flatPickerConfig"
                        placeholder="HH:MM:SS" />
            <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
                                     :state="errors && ('camp_back' in errors) ? false : null">
              {{ $t(errors.camp_back[0]) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit">
              {{ $t('Save')}}
            </b-button>
          </div>

          </b-col>
        </b-form>
</template>


<script>
import {
  BCol, BRow, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  emits:['onSubmit'],
  props: {
    data: {
      type: Object,
      required: true,
    },
    errors:{
        type:Object,
        required: true,
    }
  },
  setup(props, { emit }) {

    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",
    }

    return { flatPickerConfig }
  },
}
</script>